module.exports = __webpack_public_path__ + "static/media/blue.cf0afc92.png";